import React from 'react';
import { Icon } from '@umijs/max';
import { createFromIconfontCN } from '@ant-design/icons';
import IconList from "@/assets/js/icons.js";

// const MyIcon = createFromIconfontCN({
//   scriptUrl: 'at.alicdn.com/t/c/font_4653685_0ydok6i84hfl.js',
// });

const MyIcon = createFromIconfontCN(IconList);

const CustomIcon: React.FC<any> = ({ name, styles, onClick }) => {
  return <MyIcon type={`icon-${name}`} style={{ ...styles }} onClick={onClick} />
}

export default CustomIcon;